import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Customer } from '@utils/types/back-office/customer-bo.ts';

export const useGetCustomerById = (id: number) => {
  const fetchCustomer = async () => {
    const response = await Axios.get<Customer>(
      `${GET_URL(id.toString()).customerBo}`
    );
    return response.data;
  };

  return useQuery<Customer, AxiosError<BaseError>>(
    ['customer', id],
    fetchCustomer,
    {
      useErrorBoundary: false
    }
  );
};
